import React, { FunctionComponent } from "react";
import { Box } from "designSystem/index";
import { grey } from "designSystem/styles/color";

const PREFIX = "ThreeDots";

const classes = {
	dot1: `${PREFIX}dot1`,
	dot2: `${PREFIX}dot2`,
};

const threeDotsStyles = (props) => ({
	"@keyframes threedots": {
		"0%, 80%, 100%": {
			transform: "scale(0)",
		},
		"40%": {
			transform: "scale(1.0)",
		},
	},
	["& > div"]: {
		animation: "threedots 1.4s infinite ease-in-out both",
		backgroundColor: props.color || grey.A100,
		borderRadius: "100%",
		display: "inline-block",
		margin: "2px",
		height: props.size || 20,
		width: props.size || 20,
	},
	[`& .${classes.dot1}`]: {
		animationDelay: "-0.32s !important",
	},
	[`& .${classes.dot2}`]: {
		animationDelay: "-0.16s !important",
	},
});

interface ThreeDotsProps {
	/** color of dots */
	color?: string;

	/** size of dots in pixels */
	size?: number;
}

const ThreeDots: FunctionComponent<ThreeDotsProps> = (props) => {
	const styles = threeDotsStyles(props);

	return (
		<Box sx={styles}>
			<div className={classes.dot1} />
			<div className={classes.dot2} />
			<div />
		</Box>
	);
};

export default ThreeDots;